import { setRoomState } from '.'
import type { StreamType } from '../../../../types'
import { goToRoom } from '../../../actions/nav'
import { subscribeRoom, swapRoom, unsubscribeRoom } from '../../../actions/room'
import { HEALTH } from '../../../constants/enums'
import { getRoomsState } from '../../getState'
import { pubSubHealth, pubSubUsers } from '../../pubSub'
import {
    clearRoomMessagesState,
    clearRoomTipState,
    removeEndOfShowMessage,
    resolveClubShowMessage,
    resolveShowExitMessages,
    setRoomIDState,
    setRoomMessagesStaleState,
} from '../../state.rooms'
import { idToSlug } from '../users'

pubSubUsers.on(
    'UPDATE:subscribed',
    ({ current: isSubscribed, id }: { current: boolean; id: number }) => {
        const { [id]: existingRoomState } = getRoomsState()

        if (!existingRoomState) {
            if (isSubscribed) {
                unsubscribeRoom(id)
            }

            return
        }

        // console.log(
        //     `[app-state: room ${id}] "isSubscribed" changed. ` +
        //         `Current: ${isSubscribed}`, // Previous: ${existingIsSubscribed}`,
        // )
        setRoomState({ id, room: { isSubscribed } }, { immediate: true })
    },
)

pubSubUsers.on(
    'UPDATE:streamType',
    ({
        previous: previousStreamType,
        current: streamType,
        id,
    }: {
        previous: StreamType
        current: StreamType
        id: number
    }) => {
        // console.log(
        //     `[app-state: room ${id}] "streamType" changed. ` +
        //         `Current: ${streamType}, Previous: ${previousStreamType}`,
        // )

        const { [id]: existingRoomState } = getRoomsState()

        if (!existingRoomState && streamType !== 'public') {
            //
            //
            // Marc: Addressing race conditions betweeen this function and the
            // setRoomIDState when initiating a voyeur, private, or club show
            // from a PM.
            //
            //
            setRoomIDState(id)
        }

        if (!existingRoomState?.isOpen && streamType !== 'public') {
            goToRoom(idToSlug[id])
        }

        if (streamType && !previousStreamType) {
            //
            // Marc:
            // Scenario
            // User SSR into room or came in fresh into the room from somewhere
            //
            subscribeRoom(id, { streamType })
            return
        }

        if (streamType === 'voyeur' && previousStreamType === 'public') {
            setRoomIDState(id)

            //
            // Marc:
            // Scenario
            // User wants to go into a "voyeur" show, in this case, we are
            // already subscribed to public and there's nothing we need to do
            //
            removeEndOfShowMessage(id)
            return
        }

        if (streamType) {
            clearRoomMessagesState(id)
            clearRoomTipState(id)
        }

        if (previousStreamType && streamType) {
            swapRoom(id, {
                unsubscribeStreamType: previousStreamType,
                subscribeStreamType: streamType,
            })

            if (streamType !== 'public' || previousStreamType === 'public') {
                return
            }

            resolveShowExitMessages(id, previousStreamType)
        }
    },
)

pubSubUsers.on(
    'UPDATE:isClubShow',
    ({ current: isClubShow, id }: { current: boolean; id: number }) => {
        const { [id]: existingRoomState } = getRoomsState()

        if (!existingRoomState) {
            return
        }

        resolveClubShowMessage(isClubShow, id)
    },
)

pubSubHealth.on('HEALTH', (status) => {
    if (status.current === HEALTH.DISCONNECTED) {
        return
    }
    Object.keys(getRoomsState()).forEach((id) => {
        setRoomMessagesStaleState(true, Number(id))
        // clearRoomMessagesState(Number(id))
    })
})
